<template>
  <v-app>
    <v-app-bar
      app
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <div class="tw-ml-3 tw-flex tw-items-center tw-h-full tw-pl-0">
        <img
          class="tw-h-10"
          :src="require('@/assets/images/logo-lean.png')"
          alt="Rechnungsfuchs"/>
        <h1 class="tw-text-2xl sm:tw-text-3xl tw-ml-3">{{this.$attrs.siteTitle}}</h1>
      </div>
      <v-spacer></v-spacer>
      <UserSection class="user-section" />
    </v-app-bar>

    <v-footer app class="tw-gap-4" style="background-color: #f5f5f5; padding: 6px 16px; position: fixed;">
      <a class="hover:tw-underline" href="https://rechnungsfuchs.com/impressum/" target="_blank" style="color: #1976d2;">Impressum</a>
      <a class="hover:tw-underline" href="https://rechnungsfuchs.com/datenschutz/" target="_blank" style="color: #1976d2;">Datenschutz</a>

      <span>&copy; {{ currentYear }}</span>

      <div class="tw-hidden sm:tw-flex tw-flex-wrap tw-gap-2" style="color: #1976d2;">
        <span class="tw-font-semibold">Empfehlung:</span>
        <a class="hover:tw-underline tw-font-normal" href="https://www.stb-wiederkehr.de/" target="_blank">Steuerberater</a>
        <span>|</span>
        <a class="hover:tw-underline tw-font-normal" href="https://business.revolut.com/signup?promo=b2b-ref-025-H2-TXL&ext=f0b7f0cf-51dc-47d8-873b-b2e9b633d10f&context=B2B_REFERRAL" target="_blank">Konto für Selbständige</a>
      </div>

      <span class="tw-hidden sm:tw-inline-block tw-text-gray-400">Partnerlinks</span>
    </v-footer>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list>
        <v-list-item v-for="(item, index) in items" :key="index" :to="item.route" link>
          <template #prepend>
            <v-icon>{{ item.icon }}</v-icon>
          </template>
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item to="/cashflow" link>
          <template #prepend>
            <v-icon>mdi-chart-bar</v-icon>
          </template>
          <v-list-item-title>
            Übersicht - Umsatz
          </v-list-item-title>
        </v-list-item>

        <v-list-item to="/all-documents" link>
          <template #prepend>
            <v-icon>mdi-file-document</v-icon>
          </template>
          <v-list-item-title>
            Alle Dokumente
          </v-list-item-title>
        </v-list-item>

        <v-list-item to="/all-recurring-invoices" link>
          <template #prepend>
            <v-icon>mdi-sync</v-icon>
          </template>
          <v-list-item-title>
            Alle Abonnements
          </v-list-item-title>
        </v-list-item>

        <v-list-item to="/all-clients" link>
          <template #prepend>
            <v-icon>mdi-account-outline</v-icon>
          </template>
          <v-list-item-title>
            Alle Kunden
          </v-list-item-title>
        </v-list-item>

        <v-list-item to="/my-company" link>
          <template #prepend>
            <v-icon>mdi-city</v-icon>
          </template>
          <v-list-item-title>
            Einstellungen
          </v-list-item-title>
        </v-list-item>

        <v-list-item to="/pricing" link>
          <template #prepend>
            <v-icon>mdi-information-outline</v-icon>
          </template>
          <v-list-item-title>
            Preise
          </v-list-item-title>
        </v-list-item>

        <v-list-item link href="https://rechnungsfuchs.com/definition-zugferd/" target="_blank">
          <template #prepend>
            <v-icon>mdi-help-circle-outline</v-icon>
          </template>
          <v-list-item-title>
            ZUGFeRD Rechnung
          </v-list-item-title>
        </v-list-item>

        <v-list-item link href="https://rechnungsfuchs.com/definition-x-rechnung/" target="_blank">
          <template #prepend>
            <v-icon>mdi-help-circle-outline</v-icon>
          </template>
          <v-list-item-title>
            X-Rechnung
          </v-list-item-title>
        </v-list-item>
      </v-list>

      <v-list class="v-list-video tw-mt-10 tw-cursor-pointer" @click="openSplineCard">
        <iframe
          class="tw-pointer-events-none"
          src="https://my.spline.design/nizo80moviecamera-40b856fe578844582ec98d1745ff0243/"
          frameborder="0"
          width="100%"
          height="152"
        ></iframe>

        <v-list-item>
          <template #prepend>
            <v-icon>mdi-video-outline</v-icon>
          </template>
          <v-list-item-title>
            Videoanleitung
          </v-list-item-title>
        </v-list-item>
      </v-list>

      <div v-if="deferredPrompt" class="tw-px-4 tw-py-6 tw-flex tw-justify-center">
        <button @click="installPWA" class="fox-invoice-action__create-btn fox-invoice-action__create-btn--gradient tw-flex tw-items-center">
          <DownloadIcon :color="'white'" />
          <span class="tw-text-white">Download - App</span>
        </button>
      </div>
    </v-navigation-drawer>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import UserSection from '@/components/User/UserSection.vue'
import DownloadIcon from '@/components/Icon/DownloadIcon.vue'

export default {
  name: 'DashboardLayout',
  computed: {},
  components: {
    UserSection,
    DownloadIcon
  },
  data () {
    return {
      drawer: !['Login', 'Register', 'PasswordReset'].includes(this.$route.name),
      items: [
        { title: 'Rechnung', icon: 'mdi-file', route: '/dashboard/invoice' },
        { title: 'Angebot', icon: 'mdi-calculator', route: '/dashboard/offer' },
        { title: 'Brief', icon: 'mdi-email-outline', route: '/dashboard/letter' }
      ],
      currentYear: new Date().getFullYear(),
      deferredPrompt: null
    }
  },
  watch: {
    '$route.name' (newName) {
      this.drawer = !['Login', 'Register', 'PasswordReset'].includes(newName)
    }
  },
  mounted () {
    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
  },
  beforeUnmount () {
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
  },
  methods: {
    openSplineCard () {
      const windowFeatures = 'left=200,top=200,width=700,height=500'
      // replace later with link to demo video
      window.open('https://my.spline.design/nizo80moviecamera-40b856fe578844582ec98d1745ff0243/', 'popup', windowFeatures)
    },
    handleBeforeInstallPrompt (e) {
      e.preventDefault()
      this.deferredPrompt = e
    },
    async installPWA () {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt()
        await this.deferredPrompt.userChoice
        this.deferredPrompt = null
      } else {
        alert('Installation failed.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list-item {
  &::before {
    display: none;
  }

  &:hover {
    background: linear-gradient(248deg, rgba(251, 59, 31, 0.65) -2.45%, rgba(248, 42, 63, 0.65) 42.25%, rgba(239, 0, 138, 0.65) 95.81%) !important;
    color: white !important;

    i::before {
      color: white !important;
    }
  }

  &.v-list-item--active {
    background: linear-gradient(248deg, #FB3B1F -2.45%, #F82A3F 42.25%, #EF008A 95.81%) !important;
    color: white !important;
  }
}

.v-list.v-list-video {
  padding: 0;

  .v-list-item {
    &:hover {
      background: transparent !important;
      color: rgba(0, 0, 0, .87) !important;

      i::before {
        color: rgba(0, 0, 0, .54) !important;
      }
    }

    &.v-list-item--active {
      background: transparent !important;
      color: rgba(0, 0, 0, .87) !important;
    }
  }
}

.v-list-item-title {
  font-size: .8125rem;
  font-weight: 500;
  line-height: 1rem;
}
</style>
